
import { Action } from 'vuex-class';
import { Vue, Component, Watch } from "vue-property-decorator";
import LayoutLoading from "@/components/shared/layout/FblLayoutLoading.vue";
import { CustomerOutput } from '@fubonlife/tacallindiy-core-axios-sdk'
import InfoModal from "@/plugins/notification/infoModal";
import { CustomerValidateInput, CustomerValidateOutput } from '@fubonlife/tacallindiy-core-axios-sdk'


@Component({ components: { LayoutLoading } })
export default class Insure_step1 extends Vue {
	@Action('setLoading') setLoading;

	// 轉換日期為民國年
	public formatter = this.$twDateFormatter;

	form = {
		custId: "",
		mobile: "",
		birthday: null,
	};
	me = null;

	callInNumber: string

	// 自定義檢核狀態(antd-vue 驗證有4種狀態: error、success、warning、validating)
	validStatus: { [key: string]: string } = {
		custId: "",
		mobile: "",
		birthday: "",
	};

	// 自定義錯誤訊息
	customErrorMsg: { [key: string]: string } = {
		custId: "",
		mobile: "",
		birthday: "",
	};

	async created() {
		this.me = this.$user.getMe();
		if(!this.me){
			// 轉逾時頁面
			this.$router.replace({ path: '/application-timeout' });
			return;
		}
		try{
			this.setLoading(true);
			await this.getCustomer();
		}finally{
			this.setLoading(false);
		}
	}

	// 遮蔽身分證
	get maskedCustId() {
		return this.form.custId.replace(/(.{5}).*(.{3})/, '$1**$2');
	}

	// 遮蔽電話
	get maskedMobile() {
		return this.form.mobile.replace(/(.{3}).*(.{2})/, '$1*****$2');
	}

	async getCustomer() {
		const me = this.me;
		await this.$CustomerControllerApi.getCustomerUsingGET1(me.token)
			.then(res => {
				if (res.status === 200) {
					let cust: CustomerOutput = JSON.parse(JSON.stringify(res.data));
					if (cust.processStatus.status === 'SUCCESS') {
						this.form.custId = cust.identity;
						this.form.mobile = cust.msisdn;
						this.callInNumber = cust.callInNumber
					} else {
						InfoModal.alertModal({
							alertType: "error",
							title: "錯誤",
							content: cust.processStatus.message,
							customContent: null,
						});
					}
				} else {
					InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "使用者資訊取得失敗，請重新嘗試。",
						customContent: null,
					});
				}
			})
	}

	// 生日日期
	disabledBirthDate(current) {
		return current > new Date() || current < this.birthday100YearsAgo;
	}

	// 取得生日範圍
	get birthday100YearsAgo() {
		return new Date().setFullYear(new Date().getFullYear() - 100);
	}

	// 取得生日預設
  get birthday20YearsAgo() {
    return new Date().setFullYear(new Date().getFullYear() - 20);
  }

	// 手動觸發 antd FormModel 驗證
	triggerValidate(field: string, msg?: string) {
		if (msg) {
			this.validStatus[field] = "error";
			this.customErrorMsg[field] = msg;
		} else {
			this.validStatus[field] = "success";
			this.customErrorMsg[field] = "";
		}
	}

	// 前端檢核規則-必填
	checkRquired(value: string, requiredName: string) {
		if (!value) {
			return "請選擇" + requiredName;
		}
	}

	handleNextStep() {
		const form = this.form;
		const birthdayHasError = this.checkRquired(form.birthday, '生日');
		if (!birthdayHasError) {
			this.setLoading(true);
			const validateCustInput: CustomerValidateInput = {
				birthday: this.$dateUtils.convertDate2DateStr(form.birthday),
				siv: 'N',
				identity: form.custId,
				msisdn: form.mobile
			}
			console.log("valid cust input", validateCustInput)
			const me = this.$user.getMe();
			this.$ValidateControllerApi.customerValidateUsingPOST1(me.token, validateCustInput)
				.then(res => {
					if (res.status === 200) {
						let validateCustOutput: CustomerValidateOutput = JSON.parse(JSON.stringify(res.data));
						console.log('validateCustOutput', validateCustOutput)
						let status = validateCustOutput.processStatus.status;
						if (status === 'SUCCESS') {
							this.$global.changeRouterAndaddParam({ toRouter: 'InsureStep2' });
						} else {
							InfoModal.alertModal({
								alertType: "error",
								title: "錯誤",
								content: validateCustOutput.processStatus.message,
								customContent: null,
							});
						}
					}else{
						InfoModal.alertModal({
						alertType: "error",
						title: "錯誤",
						content: "連線失敗，請重新嘗試。",
						customContent: null,
					});
					}
				})
				.finally(() => {
					this.setLoading(false);
				})
		} else {
			this.triggerValidate("birthday", birthdayHasError);
		}
	}
}
